import { render, staticRenderFns } from "./SocialLoginForm.vue?vue&type=template&id=59098506"
import script from "./SocialLoginForm.vue?vue&type=script&lang=js"
export * from "./SocialLoginForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports